export default {
  rowCount: state => {
    if (Object.keys(state.dbRecordsList).length) {
      return state.dbRecordsList.pageObject.rowCount
    } else {
      return 0
    }
  },
  pageCount: state => {
    if (Object.keys(state.dbRecordsList).length) {
      return state.dbRecordsList.pageObject.pageCount
    } else {
      return 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/db/getters.js